import { logout } from '@/auth/utils'

//* Close session and clean user's data
export const closeAccount = {
  setup() {
    const { cleanUserData } = logout()
    const closeSession = redirect => { cleanUserData(redirect) }

    return { closeSession }
  },
}

export const _ = null
